/**
 * Query-key prefixes that are safe + useful to persist for offline navigation.
 * Kept to small, slow-changing metadata so the persisted blob fits localStorage.
 * Large/volatile data (vector features, byproducts) is intentionally excluded —
 * features are handled by the offline snapshot store instead.
 */
const PERSIST_PREFIXES = new Set([
  'me',
  'organizations',
  'projects',
  'projectFolders',
  'project',
  'layers',
  'layersNested',
  // Image-layer POI positions — needed to render image markers offline. The
  // image preview files themselves come from the offlineres cache.
  'images',
]);

export function shouldPersistQueryKey(queryKey: readonly unknown[]): boolean {
  const head = queryKey[0];
  return typeof head === 'string' && PERSIST_PREFIXES.has(head);
}
